<template>
  <div class="home-page-container" ref="container">
    <p class="title-wrapper">
      <span class="home-title"></span>
      <span class="title">Overseas Public Opinions of Chinese Brands</span>
    </p>

    <div class="card-wrapper">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card class="box-card1">
            <div class="tag-top">
              <number-title :value="siteTotals"></number-title>
              <i class="el-icon-download downLoad" @click="downLoad1"></i>
            </div>

            <div class="tag-wrapper">
              <span class="tag-title">The number of overseas websites monitored</span>
              <span class="tag-img one-img">
                <div class="small-img first-img"></div>
              </span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card2">
            <div class="tag-top">
              <number-title :value="newsTotals"></number-title>
            </div>
            <div class="tag-wrapper">
              <span class="tag-title">The number of Chinese brands tracked</span>
              <span class="tag-img two-img">
                <div class="small-img second-img"></div>
              </span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card3">
            <div class="tag-top">
              <number-title :value="brandTotals"></number-title>
            </div>
            <div class="tag-wrapper">
              <span class="tag-title">The volume of valid data</span>
              <span class="tag-img three-img">
                <div class="small-img third-img"></div>
              </span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="word-title">
      <span>The brand system covers two parts, namely, brands selected by Xinhua and the brands of the listed companies. The system mainly tracks the Chinese brand activities in more than 200 overseas mainstream media, with the aim to reflect brand building overseas. The brands selected by Xinhua are in line with the development concept of "innovation, coordination, green development, openness and sharing" and the spirit of craftsmanship and entrepreneurship.</span>
    </div>
    <div class="word-title">
      <span>
        Notice: The green sign on the lower right of the company logo means
        there are data supporting the system analysis. No green sign means there
        are temporarily no data.
      </span>
    </div>
    <!-- chart -->
    <!--<div class="module-item">
      <WordCloud class="item_components" :country="countryList" />
    </div>-->

    <div class="module-item">
      <IndustryLocal class="item_components industry" :country="countryList" />
    </div>

    <div class="module-item">
      <IndustryActivity class="item_components" :country="countryList" />
    </div>
  </div>
</template>

<script>
import NumberTitle from "./number";
import IndustryLocal from "./industryLocal";
import WordCloud from "./wordCloud";
import IndustryActivity from "./industryActivity";
import {
  getTotal,
  getHomeCountry,
  downLoad,
  downLoads,
} from "@/common/js/http/version3Api";

export default {
  components: {
    NumberTitle,
    IndustryLocal,
    WordCloud,
    IndustryActivity,
  },

  data() {
    return {
      siteTotals: 0,
      newsTotals: 0,
      brandTotals: 0,
      countryList: [],
      result: null,
      timer: null,
    };
  },

  created() {},
  mounted() {
    this.timer = setTimeout(() => {
      this.getStatisicalData();
      this.getCountry();
    }, 600);
  },
  methods: {
    async getStatisicalData() {
      this.$forceUpdate();
      const {
        result: { brandTotals, newsTotals, siteTotals },
      } = await getTotal();
      this.siteTotals = siteTotals;
      this.newsTotals = newsTotals;
      this.brandTotals = brandTotals;
    },

    async getCountry() {
      this.$forceUpdate();
      const { result } = await getHomeCountry();
      this.countryList = result;
    },
    downLoad1() {
      this.getDownData();
    },
    getDownData() {
      downLoad()
        .then((res) => {
          this.result = res;
          let enc = new TextDecoder("utf-8");
          let data = JSON.parse(enc.decode(new Uint8Array(res.data)));
          if (data && data.code === 500) {
            this.$message({
              message: data.result,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          const fileName = this.result.headers["content-disposition"]
            ? this.result.headers["content-disposition"].split("=")[1]
            : "websites.xlsx";
          const content = this.result.data;
          const blob = new Blob([content], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL;
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob);
          let downloadLink = document.createElement("a");
          downloadLink.target = "_blank";
          downloadLink.href = downloadHref;
          // downloadLink.download = "websites.xls";
          downloadLink.download = fileName;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink); //下载完成移除元素
          url.revokeObjectURL(downloadHref);
        });
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>


<style scoped>
.title-wrapper {
  padding: 32px 15px;
  color: #000000;
  letter-spacing: 0;
  font-family: RCB;
  font-size: 20px;
}
.card-wrapper >>> .el-card__body {
  height: 120px !important;
}
.tag-wrapper {
  padding-top: 15px;
  height: 45px;
  position: relative;
}
.tag-title {
  font-size: 14px;
  color: #4e5671;
  line-height: 22px;
  float: left;
  width: 80%;
  font-size: 14px;
  font-family: RCR;
}

.card-wrapper {
  padding: 0px 15px 20px;
}
.box-card1 {
  background: #e9f2fe;
  background-image: url(./images/椭圆形5@1x.png);
  background-repeat: no-repeat;
}
.box-card2 {
  background: #fff6f6;
  background-image: url(./images/半圆2@1x.png);
  background-repeat: no-repeat;
}
.box-card3 {
  background: #eefff5;
  background-image: url(./images/半圆3@1x.png);
  background-repeat: no-repeat;
}
.module-item {
  margin: 20px;
}
.tag-img {
  position: absolute;
  width: 50px;
  height: 50px;
  display: inline-block;
  background-size: 100% 100%;
  right: 0;
  bottom: -15px;
}
.one-img {
  background-image: url(./images/椭圆形1@1x.png);
}
.small-img {
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 10px auto;
}
.first-img {
  background-image: url(./images/数据1@1x.png);
}
.two-img {
  background-image: url(./images/椭圆形2@1x.png);
}
.second-img {
  background-image: url(./images/数据2@1x.png);
}
.three-img {
  background-image: url(./images/椭圆形3@1x.png);
}
.third-img {
  background-image: url(./images/数据3@1x.png);
}
.tag-top {
  position: relative;
}
.downLoad {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 20px;
}
.word-title {
  padding: 10px 15px;
  font-size: 16px;
  color: #4e5671;
  letter-spacing: 0;
  line-height: 23px;
  font-family: RCR;
}
@media screen and (max-width: 800px) {
  .card-wrapper >>> .el-col-8 {
    width: 100% !important;
    padding-top: 10px !important;
  }
  .home-page-container {
    background: #fff;
    padding-bottom: 50px;
  }
}
@media screen and (max-width: 1024px) {
  .card-wrapper >>> .el-card__body {
    height: 137.8px !important;
  }
}
</style>
